<template>
  <div class="ListadoDeComentarios">
    <v-list three-line>
      <template v-for="(comentario, index) in comentarios">
        <v-list-item
          :key="comentario.id"
        >
          <v-list-item-content>
            <!-- Texto -->
            <v-list-item-subtitle >
              <span>{{formatLocalDateTime(comentario.fecha)}} por {{getNombreSolicitante(comentario)}}</span>
              <!--<v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" >{{getNombreSolicitante(comentario)}}</span>
                </template>
                <span> {{getNombreSolicitante(comentario)}}</span>
              </v-tooltip>-->
              <br>
              <span class="font-weight-bold">{{comentario.nombreCampo}}</span>
            </v-list-item-subtitle>
            <v-list-item-content>

              <!-- Botones de acción -->
              <v-row>
                <v-col cols="12">
                  {{comentario.observacion}}
                </v-col>
              
              <v-btn v-if="habilitarCRUD && !comentario.visibleAutonomo" class="mt-1 justify-start" color="rgb(18, 77, 145)" text @click="openModal(comentario, eliminar)" >
                <v-icon> mdi-delete-outline</v-icon>
                <span class="text-decoration-underline" >Eliminar comentario</span>
              </v-btn>
              <v-btn v-if="habilitarCRUD && !comentario.visibleAutonomo" class="mt-1 justify-start" color="rgb(18, 77, 145)" text @click="openModal(comentario, editar)" >
                <v-icon> mdi-pencil-outline</v-icon>
                <span class="text-decoration-underline" >Editar comentario</span>
              </v-btn>
              </v-row>

            </v-list-item-content>
          </v-list-item-content>
        </v-list-item>
        <v-divider :key="index"></v-divider>
      </template>
    </v-list>
    <!-- Modal confirmación eliminar -->
    <ModalGenericoAccion v-model="eliminar.showDialogo" :titulo="eliminar.titulo" :width="'30%'">
      <template #botonPrincipal>
        <v-btn color="error" @click="eventClickDelete(), closeModal(eliminar)" >
          <v-icon left>
            mdi-delete-outline
          </v-icon>
          Sí, eliminar
        </v-btn>
      </template>
    </ModalGenericoAccion> 
    <!-- Modal editar texto -->
    <ModalGenericoAccion v-model="editar.showDialogo" :titulo="editar.titulo" :width="'45%'">
      <template #texto>
        <v-card-text class="px-0">
          <v-col cols="12" justify="end">
            <v-textarea class="text-body-1 mx-0" rows="3" outlined :rules="[validationRules.maxLength(comentario.observacion, 2000)]"
              counter="2000" v-model="comentario.observacion"/>    
          </v-col> 
        </v-card-text>
      </template>
      <template #botonPrincipal>
        <v-btn color="primary" @click="eventClickUpdate(), closeModal(editar)" :disabled="comentario.observacion && !comentario.observacion.trim() || comentario.observacion.length > 2000" >
          Guardar
        </v-btn>
      </template>
    </ModalGenericoAccion> 
  </div>
  
</template>

<script>
//import { mapGetters, mapActions } from 'vuex';
import api from '@Base/services/auditoriaService';
import StepBase from './StepBase';
import ModalGenericoAccion from './ModalGenericoAccion.vue';
export default {
  name: 'ListaComentarios',
	mixins: [StepBase],
  components: {
    ModalGenericoAccion
  },
  props: ['campo', 'comentarios', 'habilitarCRUD'],
  data: () => ({
    eliminar: {
      showDialogo: false,
      titulo: '¿Desea eliminar el comentario?'
    },
    editar: {
      showDialogo: false,
      titulo: 'Editar comentario',
    },
    comentario: {},
  }),

  computed: {		
    /*...mapGetters({
    }),*/
  },

  watch:{
  },
  
  methods:{
    /*...mapActions({
      delete: 'comentarios/deleteComentario',
      update: 'comentarios/updateComentario'
    }),*/

		getNombreSolicitante(comentario) {
			if (comentario.nif == this.$store.state.solicitud.solicitante.dni) {
				if (!this.$store.state.solicitud.solicitante.apellido2) {
					return `${this.$store.state.solicitud.solicitante.apellido1}, ${this.$store.state.solicitud.solicitante.nombre}`;
				}
				return `${this.$store.state.solicitud.solicitante.apellido1} ${this.$store.state.solicitud.solicitante.apellido2}, ${this.$store.state.solicitud.solicitante.nombre}`;
			}
      if(comentario.nif !== this.$store.state.solicitud.solicitante.dni){
        return comentario.iniciales;
      }
			
      return '???';
		},

    openModal(comentario = {}, modal = {}) {
      this.comentario = { ...comentario };
      modal.showDialogo = true;
    },

    closeModal(modal = {}) {
      this.selected = null;
      modal.showDialogo = false;
    },

    eventClickUpdate () {
      let payload = {
        id: this.comentario.id,
        campo: this.campo.id,
        expediente: this.campo.idSolicitud,
				fecha: new Date().getTime(),
        observacion: this.comentario.observacion,
				nif: this.$store.state.solicitud.solicitante.dni
      };

      api.editarComentarioDeCampo(payload,
			res => {
        this.$emit('reload');
      },
			err => {
			});
    },

    eventClickDelete() {
      api.borrarComentarioDeCampo(this.comentario.id,
			res => {
				this.$emit('reload');
      },
			err => {
			});
    },

    noSolicitante(nombre = "") {
      return typeof nombre === 'string' && nombre.trim().toLowerCase() !== "solicitante";
    }
  },
}
</script>

<style>
</style>